import { Clear, LocalPrintshopOutlined, Search } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  useTheme,
} from "@mui/material";

import useStyles from "./styles";
import dayjs from "dayjs";
import { useOutletContext } from "react-router-dom";
import { useEffect, useState } from "react";
import customParseFormat from "dayjs/plugin/customParseFormat";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import DatagridComponent from "../../../../components/datagridComponent";
import FilterBar from "../../../../components/topBarFilter";
import GrupoChip from "../../../../components/grupoEconomico/GrupoChip";
import axios from "axios";
dayjs.extend(customParseFormat);
export default function NotaFiscal() {
  const { apiCliente, controllerDashboard, setControllerDashboard } =
    useOutletContext();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [clienteInfo, setClienteInfo] = useState({});

  //TIPOS DE NF
  const [allNfs, setAllNfs] = useState([]); //Todas as notas
  const [rowsNf, setRowsNf] = useState([]);
  const [notasFiscais, setNotasFiscais] = useState([]); //Notas fiscais modelo 21/22
  const [nfes, setNfes] = useState([]); //Notas fiscais modelo 55 (NFE)
  const [nfses, setNfses] = useState([]); //Notas fiscais modelo PREFEITURA (NFSE)
  const [nfcoms, setNfcoms] = useState([]); //Notas fiscais modelo 62 (NFCOM)
  const [loadingNf, setLoadingNf] = useState(false);
  const [buscarNf, setBuscarNf] = useState("");
  const [allModeloNf, setAllModeloNf] = useState([]);
  const [selectModelo, setSelectModelo] = useState("");
  const [openFilter, setOpenFilter] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Usuário de grupo econômico: as NFs consolidadas chegam com o membro
  // dono (ownerNome) — exibe a coluna "Empresa" somente nesse caso
  const temEmpresaGrupo = allNfs?.some((row) => !!row?.ownerNome);

  const filteredRowsNf = rowsNf?.filter((row) => {
    const matchesText =
      row.modelo?.toLowerCase()?.includes(buscarNf?.toLowerCase()) ||
      row.ownerNome?.toLowerCase()?.includes(buscarNf?.toLowerCase()) ||
      dayjs(row.dataEmissao)
        .format("DD/MM/YYYY")
        ?.toLowerCase()
        ?.includes(buscarNf?.toLowerCase());

    return matchesText;
  });

  useEffect(() => {
    if (clienteInfo?.usuarioCliente?.clienteId) {
      getNfs();
    }
  }, [clienteInfo]);
  useEffect(() => {
    setRowsNf(
      selectModelo?.id === 1
        ? notasFiscais
        : selectModelo?.id === 2
          ? nfes
          : selectModelo?.id === 3
            ? nfses
            : selectModelo?.id === 4
              ? nfcoms
              : allNfs,
    );
  }, [selectModelo]);

  useEffect(() => {
    setClienteInfo(JSON.parse(localStorage.getItem("userCliente")));

    return () => {
      if (controllerDashboard) {
        controllerDashboard.abort();
      }
    };
  }, []);
  const getNfs = async () => {
    if (controllerDashboard) {
      controllerDashboard.abort();
    }
    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);
    setLoadingNf(true);
    try {
      const response = await apiCliente.post(
        "/cliente/find/nf",
        {
          clienteId: clienteInfo?.usuarioCliente?.clienteId,
        },
        {
          signal,
        },
      );

      setAllModeloNf(response?.data?.modelos);
      // Chave da linha: ERP + número (grupo econômico: o número se repete
      // entre ERPs; fora dele, a mesma de antes).
      const comChave = (notas) =>
        (notas || []).map((nota) =>
          nota?.erpId ? { ...nota, id: `${nota.erpId}-${nota.id}` } : nota,
        );
      const notasFiscais = comChave(response?.data?.notas_fiscais);

      const nfes = comChave(response?.data?.nfes);
      const nfses = comChave(response?.data?.nfses);
      const nfcoms = comChave(response?.data?.nfcoms);

      setNotasFiscais(notasFiscais);
      setNfes(nfes);
      setNfses(nfses);
      setNfcoms(nfcoms);

      const allNotas = [...notasFiscais, ...nfes, ...nfses, ...nfcoms];
      setRowsNf(allNotas);
      setAllNfs(allNotas);
    } catch (error) {
      console.error("Error fetching faturaws:", error);
      /* setSnackbar({
        message: "Erro ao buscar NFs",
        severity: "error",
      }); */
    } finally {
      setLoadingNf(false);
    }
  };

  const columnsNf = [
    {
      field: "cliente",
      headerName: "Cliente",
      flex: 1,
      renderCell: (params) =>
        `${params?.row?.cliente?.codigo_cliente || ""}  - ${
          params?.row?.cliente?.nome || ""
        }`,
    },
    // Coluna exibida apenas para usuários de grupo econômico (IXC)
    ...(temEmpresaGrupo
      ? [
          {
            field: "ownerNome",
            headerName: "Empresa",
            flex: 1,
            renderCell: (params) =>
              params?.row?.ownerNome ? (
                <GrupoChip variant="owner" label={params?.row?.ownerNome} />
              ) : (
                ""
              ),
          },
        ]
      : []),
    {
      field: "modelo",
      headerName: "Modelo",
      flex: 1,
    },
    {
      field: "dataEmissao",
      headerName: "Data de Emissão/Cadastro",
      flex: 1,
      valueGetter: (params) => {
        const date = dayjs(params).format("DD/MM/YYYY");
        return date;
      },
    },
    {
      field: " ",
      headerName: " ",
      maxWidth: 16,
      sortable: false,

      renderCell: (params) => (
        <IconButton
          onClick={() =>
            window.open(params.row.link, "_blank", "noopener,noreferrer")
          }
          size="small"
        >
          <LocalPrintshopOutlined fontSize="small" />
        </IconButton>
      ),
    },
  ];
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
  }, []);
  const actions = [
    {
      icon: <FilterAltOutlinedIcon />,
      name: "Filtro",
      onClick: () => setOpenFilter(true),
    },
  ];

  return (
    <>
      <FilterBar
        actions={actions}
        setOpenFilter={setOpenFilter}
        openFilter={openFilter}
        selectorComponentLeft={
          <Box sx={styles.containerActions}>
            <TextField
              label="Buscar NF"
              variant="outlined"
              autoComplete="off"
              placeholder="Modelo, data, etc..."
              value={buscarNf}
              size="small"
              onChange={(event) => {
                setBuscarNf(event?.target?.value?.trimStart());
              }}
              sx={{
                width: "100%",
                maxWidth: 500,
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
                endAdornment: buscarNf ? (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setBuscarNf("")} edge="end">
                      <Clear size={"small"} />
                    </IconButton>
                  </InputAdornment>
                ) : null,
              }}
            />
            <Autocomplete
              id="free-solo-demo"
              value={selectModelo}
              disabled={loadingNf}
              size="small"
              sx={{
                width: "100%",
                maxWidth: 500,
              }}
              options={allModeloNf || []}
              getOptionLabel={(option) => option?.modelo || ""}
              onChange={(event, newValue) => {
                setSelectModelo(newValue);
              }}
              renderInput={(params) => <TextField {...params} label="Modelo" />}
            />
          </Box>
        }
        selectorComponentRight={<Box sx={{ width: "1px" }} />}
      />
      <Paper
        sx={styles.containerPaper}
        elevation={theme.palette.mode === "dark" ? 0 : 3}
      >
        <Box sx={styles.boxDatagrid}>
          <DatagridComponent
            loading={loadingNf}
            rows={filteredRowsNf}
            columns={columnsNf}
          />
        </Box>
      </Paper>
    </>
  );
}
